import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Painel from './pages/Painel';
import Bots from './pages/Bots';
import AIInsights from './pages/AIInsights';
import Backtest from './pages/Backtest';
import Models from './pages/Models';
import Futures from './pages/Futures';
import Login from './pages/Login';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Painel />} />
          <Route path="/bots" element={<Bots />} />
          {/* Redirecionamentos da consolidacao de UX (fases 1 e 2) — bookmarks antigos continuam funcionando.
              Market/Trades/AIInsights vivem dentro do Painel; AIInsights mantem rota propria (analise profunda). */}
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/market" element={<Navigate to="/" replace />} />
          <Route path="/trades" element={<Navigate to="/" replace />} />
          <Route path="/insights" element={<AIInsights />} />
          <Route path="/arena" element={<Navigate to="/bots?mode=arena" replace />} />
          <Route path="/brains" element={<Navigate to="/bots" replace />} />
          <Route path="/bot" element={<Navigate to="/bots" replace />} />
          <Route path="/backtest" element={<Backtest />} />
          <Route path="/models" element={<Models />} />
          <Route path="/futures" element={<Futures />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
